import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { ajaxUrl } from './util';
export var request = function request(config) {
  return new Promise(function (resolve, reject) {
    var _config$url = config.url,
      url = _config$url === void 0 ? '' : _config$url,
      _config$method = config.method,
      method = _config$method === void 0 ? 'get' : _config$method,
      _config$params = config.params,
      params = _config$params === void 0 ? {} : _config$params,
      _config$header = config.header,
      header = _config$header === void 0 ? {} : _config$header,
      _config$timeout = config.timeout,
      timeout = _config$timeout === void 0 ? 200000 : _config$timeout;
    // 发送ajax请求
    var xhr = new XMLHttpRequest();
    xhr.open(method, ajaxUrl(url, params), true);
    xhr.withCredentials = true;
    var headerKeys = Object.keys(header);
    if (headerKeys.length > 0) {
      headerKeys.forEach(function (item) {
        xhr.setRequestHeader(item, header[item]);
      });
    }
    xhr.timeout = timeout;
    xhr.ontimeout = function () {
      var timeoutMessage = "timeout of ".concat(timeout, "ms exceeded");
      var error = new Error(timeoutMessage);
      reject(error);
    };
    xhr.onload = function () {
      resolve(JSON.parse(xhr.responseText || ''));
    };
    xhr.onerror = function (e) {
      reject(e);
    };
    xhr.send();
  });
};